(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name commons.service:CommonLogicsService
     *
     * @description
     *
     */
    angular
        .module('commons')
        .service('CommonLogicService', CommonLogicService);

    function CommonLogicService(applicationConstants, ApplicationService, CommonMasterData) {
        var self = this;
        /**
         * Calculate duty hours
         * @param startDate
         * @param startTime
         * @param endDate
         * @param endTime
         * @param percentage
         * @returns {string}
         */
        self.calculateDutyHours = function (startDate, startTime, endDate, endTime, percentage) {
            var hourValue = "00:00";
            if (startDate !== '' && startTime !== '' && endDate !== '' && endTime !== '') {
                if (startDate===null){
                    startDate="01/01/2000";
                }
                if (endDate===null){
                    endDate="01/01/2000";
                }
                if(percentage===undefined){
                    percentage = 100;
                }
                var start_Time = moment(startDate + ' ' + startTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                var end_Time = moment(endDate + ' ' + endTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                var ms = end_Time.diff(start_Time);
                var validPeriod = ms * percentage / 100;
                var d = moment.duration(validPeriod);
                if (ms > 0) {
                    hourValue = Math.floor(d.asHours()) + moment.utc(validPeriod).format(":mm");
                }
            }
            return hourValue;
        };

        /**
         * Get a Random ID
         * @returns {string}
         */
        self.getRandomID = function () {
            var text = "";
            var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 6; i++) {
                text += possible.charAt(Math.floor(Math.random() * possible.length));
            }
            return text;
        };

        self.checkDate = function(strId){
            dateChk(strId);
        };

        self.getIndexInList = function (List, item, flag) {
            var _index = -1;
            for(var i=0;i<List.length;i++){
                if(List[i][flag] === item[flag]){
                    _index = i;
                    break;
                }
            }
            return _index;
        };

        /**
         * Taken from "Auto Date Generator (Fully client side)" Author: Rilwan A. Latiff  Version:1.0
         * Thanks to Latiff
         * @param strID
         * @returns {*}
         */
        var mmArray = ["January","February","March","April","May","June","July","August","September","October","November","December"];
        function dateChk(ele){
            var arrMonth = mmArray;
            var dtToday = new Date();
            var dtCurrD	= dtToday.getDate();
            var dtCurrM	= (dtToday.getMonth() + 1);
            var dtCurrY	= dtToday.getFullYear();

            var objC = ele;
            var strEValue = "";
            if (objC == null){
                strEValue = strID;
            }else{
                strEValue = objC.value
            }


            var blnReturn = true;
            var dtCreatD = dtCurrD;
            var dtCreatM = dtCurrM;
            var dtCreatY = dtCurrY;

            strEValue = replaceall(strEValue, "/", "^");
            strEValue = replaceall(strEValue, "-", "^");
            strEValue = replaceall(strEValue, ".", "^");
            strEValue = replaceall(strEValue, " ", "^");
            if (strEValue.indexOf("^") != -1){
                var arrDts = strEValue.split("^");
                switch (arrDts.length){
                    case 1 :
                        if (String(arrDts[0]) != ""){dtCreatD = arrDts[0];}
                        break;
                    case 2 :
                        if (String(arrDts[0]) != ""){dtCreatD = arrDts[0];}
                        if (String(arrDts[1]) != ""){dtCreatM = arrDts[1];}
                        break;
                    case 3 :
                        if (String(arrDts[0]) != ""){dtCreatD = arrDts[0];}
                        if (String(arrDts[1]) != ""){dtCreatM = arrDts[1];}
                        if (String(arrDts[2]) != ""){dtCreatY = arrDts[2];}
                        break;
                }
            }else{
                var intCLength = strEValue.length;
                for (var i = 0 ; i < intCLength ; i++){
                    if (i <= 1){
                        if (i == 0){dtCreatD = "";}
                        dtCreatD += strEValue.substr(i,1);
                    }

                    if (i > 1 && i <= 3){
                        if (i == 2){
                            if (intCLength >= 4){
                                dtCreatM = "";
                                dtCreatM += strEValue.substr(i,1);
                            }else{
                                if (strEValue.substr(i,1) != 0){
                                    dtCreatM = "";
                                    dtCreatM += strEValue.substr(i,1);
                                }
                            }
                        }else{
                            dtCreatM += strEValue.substr(i,1);
                        }
                    }

                    if (i > 3 && i <= 7){
                        if (i == 4){dtCreatY = "";}
                        dtCreatY += strEValue.substr(i,1);
                    }
                }
            }

            // ------------------------------------ Validate
            if (!validDate(dtCreatD, dtCreatM, dtCreatY)){
                switch (strEValue.length){
                    case 2 :
                        if (Number(strEValue.substr(0,1)) > 0){dtCreatD = strEValue.substr(0,1);}
                        if (Number(strEValue.substr(1,1)) > 0){dtCreatM = strEValue.substr(1,1);}
                        break;
                    case 3:
                        if (Number(strEValue.substr(1,2)) <= 12) {
                            if (Number(strEValue.substr(0,1)) > 0){dtCreatD = strEValue.substr(0,1);}
                            if (Number(strEValue.substr(1,2)) > 0){dtCreatM = strEValue.substr(1,2);}
                        }else{
                            if (Number(strEValue.substr(0,1)) > 0){dtCreatD = strEValue.substr(0,1);}
                            if (Number(strEValue.substr(1,1)) > 0){dtCreatM = strEValue.substr(1,1);}
                            if (Number(strEValue.substr(2,1)) > 0){dtCreatY = strEValue.substr(2,1);}
                        }
                    case 4:
                        if (Number(strEValue.substr(1,2)) <= 12) {
                            if (Number(strEValue.substr(0,1)) > 0){dtCreatD = strEValue.substr(0,1);}
                            if (Number(strEValue.substr(1,2)) > 0){dtCreatM = strEValue.substr(1,2);}
                            if (Number(strEValue.substr(3,1)) > 0){dtCreatY = strEValue.substr(3,1);}
                        }else{
                            if (Number(strEValue.substr(0,1)) > 0){dtCreatD = strEValue.substr(0,1);}
                            if (Number(strEValue.substr(1,1)) > 0){dtCreatM = strEValue.substr(1,1);}
                            if (Number(strEValue.substr(2,2)) > 0){dtCreatY = strEValue.substr(2,2);}
                        }
                        break;
                    default :
                        if (objC == null){
                            return "";
                        }else{
                            //objC.focus()
                            blnReturn = false;
                        }
                        break;
                }
            }

            if (!validDate(dtCreatD, dtCreatM, dtCreatY)){
                if (objC == null){
                    return "";
                }else{
                    //objC.focus()
                    blnReturn = false;
                }
            }

            if (blnReturn && strEValue != ""){
                if (dtCreatY.length < 4){
                    dtCreatY = String(dtCurrY).substr(0, (String(dtCurrY).length - dtCreatY.length)) + dtCreatY
                }else if (dtCreatY.length > 4){
                    dtCreatY = String(dtCurrY).substr(0, 4);
                }

                // ------------------------------------ Formatting the date
                var strFormat = "dd/mm/yyyy";
                if (arguments.length == 2){
                    if (arguments[1] != ""){
                        strFormat = arguments[1];
                    }
                }

                var strDefSep = "" ;
                var arrSep = new Array("/","-"," ",".");

                for (var i = 0 ; i < arrSep.length ; i++){
                    if (strFormat.indexOf(arrSep[i]) != -1){
                        strDefSep = arrSep[i];
                        break;
                    }
                }
                if (strDefSep == ""){
                    if (objC == null){
                        return "";
                    }else{
                        //objC.focus()
                        blnReturn = false;
                    }
                }

                var strReturnDt = "";
                if (Number(dtCreatD) < 10){dtCreatD = "0" + Number(dtCreatD)};
                if (Number(dtCreatM) < 10){dtCreatM = "0" + Number(dtCreatM)};
                var strFormat1  = "DD" + strDefSep + "MM" + strDefSep + "YYYY"
                var strFormat2  = "DD" + strDefSep + "MM" + strDefSep + "YY"
                var strFormat3  = "DD" + strDefSep + "MMM" + strDefSep + "YYYY"
                var strFormat4  = "DD" + strDefSep + "MMM" + strDefSep + "YY"
                var strFormat5  = "DD" + strDefSep + "MMMM" + strDefSep + "YYYY"
                var strFormat6  = "DD" + strDefSep + "MMMM" + strDefSep + "YY"
                var strFormat7  = "MM" + strDefSep + "YYYY"
                var strFormat8  = "MM" + strDefSep + "YY"
                var strFormat9  = "MMM" + strDefSep + "YYYY"
                var strFormat10 = "MMM" + strDefSep + "YY"
                var strFormat11 = "MMMM" + strDefSep + "YYYY"
                var strFormat12 = "MMMM" + strDefSep + "YY"


                var strDW = "th" ;
                var strCM = "," ;
                if ((dtCreatD == "01") || (dtCreatD == "21")  || (dtCreatD == "31")){strDW = "st";}
                if ((dtCreatD == "02") || (dtCreatD == "22")){strDW = "nd";}
                if ((dtCreatD == "03") || (dtCreatD == "23")){strDW = "rd";}
                if (strDefSep != " "){strDW = ""; strCM = "";}

                switch (strFormat.toUpperCase()){
                    case strFormat1	: strReturnDt = dtCreatD + strDefSep + dtCreatM + strDefSep + dtCreatY; break;
                    case strFormat2	: strReturnDt = dtCreatD + strDefSep + dtCreatM + strDefSep + String(dtCreatY).substr(2,2); break;
                    case strFormat3	: strReturnDt = dtCreatD + strDefSep + arrMonth[Number(dtCreatM)-1].substr(0,3) + strDefSep + dtCreatY; blnReturn = true; break;
                    case strFormat4	: strReturnDt = dtCreatD + strDefSep + arrMonth[Number(dtCreatM)-1].substr(0,3) + strDefSep + String(dtCreatY).substr(2,2); blnReturn = true; break;
                    case strFormat5	: strReturnDt = dtCreatD + strDW + strDefSep + arrMonth[Number(dtCreatM)-1] + strCM + strDefSep + dtCreatY; blnReturn = true; break;
                    case strFormat6	: strReturnDt = dtCreatD + strDW + strDefSep + arrMonth[Number(dtCreatM)-1] + strCM + strDefSep + String(dtCreatY).substr(2,2); blnReturn = true; break;
                    case strFormat7	: strReturnDt = dtCreatM + strDefSep + dtCreatY; break;
                    case strFormat8	: strReturnDt = dtCreatM + strDefSep + String(dtCreatY).substr(2,2); break;
                    case strFormat9	: strReturnDt = arrMonth[Number(dtCreatM)-1].substr(0,3) + strDefSep + dtCreatY; blnReturn = true; break;
                    case strFormat10: strReturnDt = arrMonth[Number(dtCreatM)-1].substr(0,3) + strDefSep + String(dtCreatY).substr(2,2); blnReturn = true; break;
                    case strFormat11: strReturnDt = arrMonth[Number(dtCreatM)-1] + strCM + strDefSep + dtCreatY; blnReturn = true; break;
                    case strFormat12: strReturnDt = arrMonth[Number(dtCreatM)-1] + strCM + strDefSep + String(dtCreatY).substr(2,2); blnReturn = true; break;

                }
                if (objC == null){
                    return strReturnDt;
                }else{
                    objC.value = strReturnDt;
                }
            }
            return blnReturn;

            // CHECK TO SEE IF YEAR IS A LEAP YEAR
            function isLeapYear (Year) {
                if (((Year % 4)==0) && ((Year % 100)!=0) || ((Year % 400)==0)) {
                    return (true);
                }
                else {
                    return (false);
                }
            }

            function replaceall(strValue, strRepValue, strNValue){
                var i = strValue.indexOf(strRepValue);
                while(i > -1){
                    strValue = strValue.replace(strRepValue, strNValue);
                    i = strValue.indexOf(strRepValue);
                }
                return strValue
            }

            function validDate(dtD, dtM, dtY){
                if ((isNaN(dtD)) || (isNaN(dtM)) || (isNaN(dtY))){
                    return false;
                }

                if ((Number(dtD) == 0) || (Number(dtM) == 0) || (Number(dtY) == 0)){
                    return false;
                }

                // is it Valid Date
                if (Number(dtM) > 12){
                    return false;
                }

                if (Number(dtD) > getDaysInMonth(dtM, dtY)){
                    return false;
                }
                return true;
            }

            function getDaysInMonth(month,year)  {
                var days;
                if (month==1 || month==3 || month==5 || month==7 || month==8 ||
                    month==10 || month==12)  days=31;
                else if (month==4 || month==6 || month==9 || month==11) days=30;
                else if (month==2)  {
                    if (isLeapYear(year)) {
                        days=29;
                    }
                    else {
                        days=28;
                    }
                }
                return (days);
            }
        }

        /**
         *
         * @param min
         * @returns {string}
         */
        self.getHoursByMinutes = function(min){
            var hours = parseInt(min/60), mins = min%60, time="";
            time = String(hours).length==1?"0"+hours:hours;
            time += ":";
            time +=String(mins).length==1?"0"+mins:mins;
            return time;
        };

        self.getStartEndDateOfRelativeToMonth = function (givenDate, offSet, OffsetVale, startEnd) {
            var MomentDate = moment(), mmD=null, returnDate=null;
            if (givenDate!==null){
                MomentDate = moment(givenDate, applicationConstants.SETTINGS.DATE_FORMAT);
            }
            if (offSet === undefined){
                offSet = 'NEXT';
            }
            if(startEnd === undefined){
                startEnd = 'START';
            }
            if (offSet.toUpperCase() === 'NEXT'){
                mmD = MomentDate.add(OffsetVale, 'months');
            }else{
                mmD = MomentDate.subtract(OffsetVale, 'months');
            }
            if(startEnd.toUpperCase() === 'START'){
                returnDate = mmD.startOf('month').format(applicationConstants.SETTINGS.DATE_FORMAT);
            }else{
                returnDate = mmD.endOf('month').format(applicationConstants.SETTINGS.DATE_FORMAT);
            }
            return returnDate;
        };

        var weeksDays = ['All', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        self.getDayOfWeeks = function(){
            var weekData = [];
            angular.forEach(weeksDays, function(day, i){
                weekData.push({
                    value: day.toLowerCase(),
                    shortName: day.slice(0,2) === 'Al'?'All':day.slice(0,2),
                    name: day,
                    selected: false,
                    editable: true,
                    index: i
                });
            });
            return weekData;
        };

        self.getMonthName = function (month) {
            return mmArray[month];
        };

        self.applyDaySelection = function (weekObj, fromDate, toDate) {
            var dayFrom = null;
            var dayTo = moment(toDate, 'DD/MM/YYYY');

            var getDayByDateName = function(dateIndex){
                var day = null;
                for (var i=0;i<weekObj.length;i++){
                    if((dateIndex+1) === weekObj[i].index){
                        day=weekObj[i];
                        break;
                    }
                }
                return day;
            }

            for (var i=0;i<weekObj.length;i++){
                weekObj[i].selected = false;
                weekObj[i].editable = false;
            }

            var j=0;
            do{
                dayFrom = moment(fromDate, 'DD/MM/YYYY').add(j,'d');
                var st = dayFrom.day();
                var stDay = getDayByDateName(st);
                stDay.editable=true;
                stDay.selected=true;
                j++;
            } while(dayTo.diff(dayFrom,'days')>0);
            weekObj[0].editable = true;
            weekObj[0].selected = true;
        };

        self.compareDateTime = function (startDate, startTime, endDate, endTime) {
            if (startDate !== '' && startTime !== '' && endDate !== '' && endTime !== '') {
                if (startDate===null){
                    startDate="01/01/2000";
                }
                if (endDate===null){
                    endDate="01/01/2000";
                }
                if (startTime===null){
                    startTime="00:00";
                }
                if (endTime===null){
                    endTime="00:00";
                }
                var start_Time = moment(startDate + ' ' + startTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                var end_Time = moment(endDate + ' ' + endTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                return end_Time.diff(start_Time)>0;
            }
        };

        self.getDateArrayForRange = function (startDate, endDate) {
            if (startDate !== null  && endDate !== null ) {
                var dateArray = [];
                var start_Time = moment(startDate, applicationConstants.SETTINGS.DATE_FORMAT);
                var end_Time = moment(endDate, applicationConstants.SETTINGS.DATE_FORMAT);
                var dayCount = start_Time.diff(end_Time, 'd');
                for(var i=0;i<=dayCount; i++){
                    var tepAddDate = start_Time.add(i,'d');
                    dateArray.push(tepAddDate.format(applicationConstants.SETTINGS.DATE_FORMAT));
                }
                return dateArray;
            }
        }

        /**
         * Calculate duration(if start and end date are same and start time is after end time
         * then considered the end date as the next date)
         * @param startDate
         * @param startTime
         * @param endDate
         * @param endTime
         * @returns {string}
         */
        self.calculateDuration = function (startDate, startTime, endDate, endTime) {
            var hourValue = "00:00";
            if (startDate !== '' && startTime !== '' && endDate !== '' && endTime !== '') {
                if (startDate===null){
                    startDate="01/01/2000";
                }
                if (endDate===null){
                    endDate="01/01/2000";
                }
                var start_Time = moment(startDate + ' ' + startTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                var end_Time = moment(endDate + ' ' + endTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                var ms = end_Time.diff(start_Time);

                //if start and end date are same get the end date as next date
                if(ms<0 && startDate === endDate){
                	end_Time = moment(moment(endDate, "DD/MM/YYYY").add(1,'d').format("DD/MM/YYYY") + ' ' + endTime, applicationConstants.SETTINGS.DATE_TIME_FORMAT);
                	ms = end_Time.diff(start_Time);
                }
                var validPeriod = ms;
                var d = moment.duration(validPeriod);
                if (ms > 0) {
                    hourValue = Math.floor(d.asHours()) + moment.utc(validPeriod).format(":mm");
                }
            }
            return hourValue;
        };

        var reportSubmitEndPoint = {
            urlFrameSet : '/frameset?__report=report',
            urlOutput : '/output?__report=report'
        }

        self.getReportUrl = function(designFileName,params,isLoginRequired, isOutput){

            var reportBaseUrl = CommonMasterData.getReportServerBaseUrl();

            if (designFileName != "app_file_download.rptdesign" && designFileName !="etsReportDownload") {
              var clientReportName = CommonMasterData.getClientReportNameByDefaultReportName(designFileName);
              if (designFileName.slice(-19) == "gd_report.rptdesign") {
                clientReportName = designFileName;
              }

              var url = reportBaseUrl + ((!!isOutput && isOutput == 'Y') ? reportSubmitEndPoint.urlOutput : reportSubmitEndPoint.urlFrameSet) + '/' + clientReportName;
              angular.forEach(Object.keys(params), function (paramName) {
                url = url + '&' + paramName + '=' + params[paramName]
              });

            }else if(designFileName =="etsReportDownload"){

              var url = reportBaseUrl + "/etsReportDownload?fromDate=" + params.fromDate +"&toDate=" + params.toDate+"&oAirport="
                      +params.oAirport+"&dAirport="+params.dAirport+"&oCountry="+params.oCountry+"&dCountry="+params.dCountry+"&flightReg="+params.flightReg+"&reportType="+params.reportDownloadType
                      +"&category="+params.category+"&operationType="+params.operationType;
            }else {
              var formDate = params.fromDate;
              var toDate = params.toDate;
              var url = reportBaseUrl + "/appFileDownload?fromDate=" + formDate +"&toDate=" + toDate;

            }

            var tenant = ApplicationService.getTenantCode();
            var tokenId = ApplicationService.getTokenId();

            url = url + '&tenant=' + (  ( tenant === undefined || tenant === null  || tenant === '' ) ? '' : tenant );
            url = url + '&token_id=' + (( tokenId === undefined || tokenId === null  || tokenId === '' ) ? '' : tokenId );


            return url;
        }


        self.getFlightInformationReportUrl = function(designFileName,params,baseUrl,tenantData,isOutput){

            var reportBaseUrl = baseUrl;

            var clientReportName = CommonMasterData.getClientReportNameByDefaultReportName(designFileName);
            var url = reportBaseUrl + ((!!isOutput && isOutput == 'Y') ? reportSubmitEndPoint.urlOutput : reportSubmitEndPoint.urlFrameSet) + '/' + clientReportName;
            angular.forEach(Object.keys(params), function (paramName) {
               url = url + '&' + paramName + '=' + params[paramName]
            });

            var tenant = tenantData;

            url = url + '&tenant=' + (  ( tenant === undefined || tenant === null  || tenant === '' ) ? '' : tenant );
            url = url + '&token_id=' +''+'&report_type='+clientReportName;

            return url;
        }

        self.getDataUrlFromResponse = function(response) {
          return new Promise(function(resolve, reject) {
            const reader = new FileReader();

            reader.onloadend = function () {
              resolve(reader.result);
            };

            reader.onerror = function () {
              reject("Error reading image data.");
            };

            reader.readAsDataURL(response);
          });
        }

        self.isPastDuty = function(dateStr) {
          const dateParts = dateStr.split('/');

          const day = parseInt(dateParts[0], 10);
          const month = parseInt(dateParts[1], 10) - 1;
          const year = parseInt(dateParts[2], 10);

          const inputDate = new Date(year, month, day);
          const today = new Date();
          today.setHours(0, 0, 0, 0);

          return inputDate <= today;
        }

    }
}());
